// extracted by mini-css-extract-plugin
export default {"input":"allowPropertiesTable_input__zNq0V","main":"allowPropertiesTable_main__wQ0pM","content":"allowPropertiesTable_content__tFcjn","header":"allowPropertiesTable_header__8-rUr"};